export const LibData={
    "ListAllBrands": {
        "API": 2,
        "Brooks": 6,
        "Creaform": 3,
        "DIY Robotics": 5,
        "Ewellix": 1,
        "Exechon": 1,
        "Fanuc": 1,
        "FARO": 1,
        "GESSMANN": 1,
        "Haas": 2,
        "Intel": 4,
        "Keyence": 1,
        "Leica": 2,
        "Lorch": 1,
        "Matrox": 1,
        "Mazak": 1,
        "MiR": 5,
        "Niryo": 1,
        "Omron": 3,
        "OnRobot": 1,
        "OpenCV": 4,
        "Physik Instrumente": 3,
        "Reis": 1,
        "Renishaw": 2,
        "RoboDK": 5,
        "SICK": 8,
        "uFactory": 1,
        "Zivid": 1
    },
    "ListAllAxes": {
        "0": 107,
        "1": 12,
        "2": 9,
        "3": 2,
        "4": 9,
        "5": 2,
        "6": 11,
        "7": 2
    },
    "ListAllTypes": {
        "AGV/AMR": 9,
        "Conveyor": 6,
        "Hexapod": 4,
        "Mechanism": 17,
        "Tricept": 1,
        "Box": 15,
        "Camera": 16,
        "Cell": 8,
        "Object": 24,
        "Pallet": 6,
        "Pedestal": 7,
        "Shape": 30,
        "Table": 5,
        "Tracker": 6
    },
    "ListAllApplications": {
        "Calibration": 6,
        "Conveying": 6,
        "HMI": 1,
        "Inspection": 22,
        "Machining": 1,
        "Palletizing": 6,
        "Welding": 1
    },
    "payloadMin": 2.0,
    "payloadMax": 100,
    "reachMin": 100,
    "reachMax": 1500,
    "weightMin": 10,
    "weightMax": 300,
    "repeatabilityMin": 0.0001,
    "repeatabilityMax": 0.1,
    "payloadMinRobot": 1000000000.0,
    "payloadMaxRobot": 0,
    "reachMinRobot": 1000000000.0,
    "reachMaxRobot": 0,
    "weightMinRobot": 1000000000.0,
    "weightMaxRobot": 0,
    "repeatabilityMinRobot": 1000000000.0,
    "repeatabilityMaxRobot": 0,
    "DATA_ALL": {
        "GESSMANN-GESSbot-Gb350": {
            "MT": "M",
            "N": "GESSMANN GESSbot Gb350",
            "F": "GESSMANN-GESSbot-Gb350.robot",
            "I": "GESSMANN-GESSbot-Gb350.png",
            "B": "GESSMANN",
            "M": "GESSbot Gb350",
            "T": "AGV/AMR",
            "A": 4
        },
        "MiR100": {
            "MT": "M",
            "N": "MiR100",
            "F": "MiR100.robot",
            "I": "MiR100.png",
            "B": "MiR",
            "M": "100",
            "T": "AGV/AMR",
            "A": 4
        },
        "MiR250": {
            "MT": "M",
            "N": "MiR250",
            "F": "MiR250.robot",
            "I": "MiR250.png",
            "B": "MiR",
            "M": "250",
            "T": "AGV/AMR",
            "A": 4
        },
        "MiR500": {
            "MT": "M",
            "N": "MiR500",
            "F": "MiR500.robot",
            "I": "MiR500.png",
            "B": "MiR",
            "M": "500",
            "T": "AGV/AMR",
            "A": 4
        },
        "MiR1000": {
            "MT": "M",
            "N": "MiR1000",
            "F": "MiR1000.robot",
            "I": "MiR1000.png",
            "B": "MiR",
            "M": "1000",
            "T": "AGV/AMR",
            "A": 4
        },
        "MiR1350": {
            "MT": "M",
            "N": "MiR1350",
            "F": "MiR1350.robot",
            "I": "MiR1350.png",
            "B": "MiR",
            "M": "1350",
            "T": "AGV/AMR",
            "A": 4
        },
        "Omron-HD-1500": {
            "MT": "M",
            "N": "Omron HD-1500",
            "F": "Omron-HD-1500.robot",
            "I": "Omron-HD-1500.png",
            "B": "Omron",
            "M": "HD-1500",
            "T": "AGV/AMR",
            "A": 4
        },
        "Omron-LD-60": {
            "MT": "M",
            "N": "Omron LD-60",
            "F": "Omron-LD-60.robot",
            "I": "Omron-LD-60.png",
            "B": "Omron",
            "M": "LD-60",
            "T": "AGV/AMR",
            "A": 4
        },
        "Omron-LD-250": {
            "MT": "M",
            "N": "Omron LD-250",
            "F": "Omron-LD-250.robot",
            "I": "Omron-LD-250.png",
            "B": "Omron",
            "M": "LD-250",
            "T": "AGV/AMR",
            "A": 4
        },
        "Conveyor-Belt-2m": {
            "MT": "M",
            "N": "Conveyor Belt (2m)",
            "F": "Conveyor-Belt-2m.robot",
            "I": "Conveyor-Belt-2m.png",
            "M": "Belt (2m)",
            "T": "Conveyor",
            "A": 1,
            "AP": [
                "Conveying"
            ]
        },
        "Conveyor-Belt-4-5m": {
            "MT": "M",
            "N": "Conveyor Belt (4.5m)",
            "F": "Conveyor-Belt-4-5m.robot",
            "I": "Conveyor-Belt-4-5m.png",
            "M": "Belt (4.5m)",
            "T": "Conveyor",
            "A": 1,
            "AP": [
                "Conveying"
            ]
        },
        "Conveyor-Belt-Assembly-2m": {
            "MT": "M",
            "N": "Conveyor Belt Assembly (2m)",
            "F": "Conveyor-Belt-Assembly-2m.rdka",
            "I": "Conveyor-Belt-Assembly-2m.png",
            "M": "Belt Assembly (2m)",
            "T": "Conveyor",
            "A": 1,
            "AP": [
                "Conveying"
            ]
        },
        "Conveyor-Belt-Wide-2m": {
            "MT": "M",
            "N": "Conveyor Belt Wide (2m)",
            "F": "Conveyor-Belt-Wide-2m.robot",
            "I": "Conveyor-Belt-Wide-2m.png",
            "M": "Belt Wide (2m)",
            "T": "Conveyor",
            "A": 1,
            "AP": [
                "Conveying"
            ]
        },
        "Conveyor-Roller-2m": {
            "MT": "M",
            "N": "Conveyor Roller (2m)",
            "F": "Conveyor-Roller-2m.robot",
            "I": "Conveyor-Roller-2m.png",
            "M": "Roller (2m)",
            "T": "Conveyor",
            "A": 1,
            "AP": [
                "Conveying"
            ]
        },
        "Conveyor-Niryo-Ned-2": {
            "MT": "M",
            "N": "Conveyor Niryo Ned 2",
            "F": "Conveyor-Niryo-Ned-2.robot",
            "I": "Conveyor-Niryo-Ned-2.png",
            "B": "Niryo",
            "T": "Conveyor",
            "A": 1,
            "P": 2.0,
            "AP": [
                "Conveying"
            ]
        },
        "Fanuc-F-200iB": {
            "MT": "M",
            "N": "Fanuc F-200iB",
            "F": "Fanuc-F-200iB.robot",
            "I": "Fanuc-F-200iB.png",
            "B": "Fanuc",
            "M": "F-200iB",
            "T": "Hexapod",
            "A": 6,
            "R": 437,
            "P": 100,
            "W": 190,
            "E": 0.1
        },
        "PI-H-811-I2": {
            "MT": "M",
            "N": "PI H-811.I2",
            "F": "PI-H-811-I2.robot",
            "I": "PI-H-811-I2.png",
            "B": "Physik Instrumente",
            "M": "H-811.I2",
            "T": "Hexapod",
            "A": 6,
            "R": 100,
            "P": 10,
            "W": 10,
            "E": 0.001
        },
        "PI-H-824": {
            "MT": "M",
            "N": "PI H-824",
            "F": "PI-H-824.robot",
            "I": "PI-H-824.png",
            "B": "Physik Instrumente",
            "M": "H-824",
            "T": "Hexapod",
            "A": 6,
            "R": 100,
            "P": 10,
            "W": 10,
            "E": 0.001
        },
        "PI-H-840-D2A": {
            "MT": "M",
            "N": "PI H-840-D2A",
            "F": "PI-H-840-D2A.robot",
            "I": "PI-H-840-D2A.png",
            "B": "Physik Instrumente",
            "M": "H-840-D2A",
            "T": "Hexapod",
            "A": 6,
            "R": 100,
            "P": 10,
            "W": 12,
            "E": 0.0001
        },
        "Brooks-PreciseFlex-100XZ-685": {
            "MT": "M",
            "N": "Brooks PreciseFlex 100XZ-685",
            "F": "Brooks-PreciseFlex-100XZ-685.robot",
            "I": "Brooks-PreciseFlex-100XZ-685.png",
            "B": "Brooks",
            "M": "PreciseFlex 100XZ-685",
            "T": "Mechanism",
            "A": 2,
            "P": 3,
            "W": 20,
            "E": 0.1
        },
        "Brooks-PreciseFlex-100XZ-1270": {
            "MT": "M",
            "N": "Brooks PreciseFlex 100XZ-1270",
            "F": "Brooks-PreciseFlex-100XZ-1270.robot",
            "I": "Brooks-PreciseFlex-100XZ-1270.png",
            "B": "Brooks",
            "M": "PreciseFlex 100XZ-1270",
            "T": "Mechanism",
            "A": 2,
            "P": 3,
            "W": 32,
            "E": 0.1
        },
        "Brooks-PreciseFlex-100XZS-685": {
            "MT": "M",
            "N": "Brooks PreciseFlex 100XZS-685",
            "F": "Brooks-PreciseFlex-100XZS-685.rdka",
            "I": "Brooks-PreciseFlex-100XZS-685.png",
            "B": "Brooks",
            "M": "PreciseFlex 100XZS-685",
            "T": "Mechanism",
            "A": 2
        },
        "Brooks-PreciseFlex-100XZS-1270": {
            "MT": "M",
            "N": "Brooks PreciseFlex 100XZS-1270",
            "F": "Brooks-PreciseFlex-100XZS-1270.rdka",
            "I": "Brooks-PreciseFlex-100XZS-1270.png",
            "B": "Brooks",
            "M": "PreciseFlex 100XZS-1270",
            "T": "Mechanism",
            "A": 2
        },
        "Brooks-PreciseFlex-100XZTS-685": {
            "MT": "M",
            "N": "Brooks PreciseFlex 100XZTS-685",
            "F": "Brooks-PreciseFlex-100XZTS-685.rdka",
            "I": "Brooks-PreciseFlex-100XZTS-685.png",
            "B": "Brooks",
            "M": "PreciseFlex 100XZTS-685",
            "T": "Mechanism",
            "A": 2,
            "P": 2,
            "W": 20,
            "E": 0.1
        },
        "Brooks-PreciseFlex-100XZTS-1270": {
            "MT": "M",
            "N": "Brooks PreciseFlex 100XZTS-1270",
            "F": "Brooks-PreciseFlex-100XZTS-1270.rdka",
            "I": "Brooks-PreciseFlex-100XZTS-1270.png",
            "B": "Brooks",
            "M": "PreciseFlex 100XZTS-1270",
            "T": "Mechanism",
            "A": 2,
            "P": 2,
            "W": 32,
            "E": 0.1
        },
        "Ewellix-LIFTKIT-Vertical-Axis": {
            "MT": "M",
            "N": "Ewellix LIFTKIT Vertical Axis",
            "F": "Ewellix-LIFTKIT-Vertical-Axis.rdka",
            "I": "Ewellix-LIFTKIT-Vertical-Axis.png",
            "B": "Ewellix",
            "M": "LIFTKIT Vertical Axis",
            "T": "Mechanism",
            "A": 1
        },
        "Generic-Quadcopter-Drone": {
            "MT": "M",
            "N": "Generic Quadcopter Drone",
            "F": "Generic-Quadcopter-Drone.robot",
            "I": "Generic-Quadcopter-Drone.png",
            "M": "Quadcopter Drone",
            "T": "Mechanism",
            "A": 6
        },
        "Generic-small-turntable": {
            "MT": "M",
            "N": "Generic small turntable",
            "F": "Generic-small-turntable.robot",
            "I": "Generic-small-turntable.png",
            "M": "small turntable",
            "T": "Mechanism",
            "A": 1
        },
        "Haas-UMC-350HD": {
            "MT": "M",
            "N": "Haas-UMC-350HD",
            "F": "Haas-UMC-350HD.rdka",
            "I": "Haas-UMC-350HD.png",
            "B": "Haas",
            "M": "-UMC-350HD",
            "T": "Mechanism",
            "A": 3
        },
        "Haas-UMC-500": {
            "MT": "M",
            "N": "Haas-UMC-500",
            "F": "Haas-UMC-500.rdka",
            "I": "Haas-UMC-500.png",
            "B": "Haas",
            "M": "-UMC-500",
            "T": "Mechanism",
            "A": 3
        },
        "Keyence-GT2": {
            "MT": "M",
            "N": "Keyence GT2",
            "F": "Keyence-GT2.robot",
            "I": "Keyence-GT2.png",
            "B": "Keyence",
            "M": "GT2",
            "T": "Mechanism",
            "A": 1
        },
        "Mazak-i200": {
            "MT": "M",
            "N": "Mazak i200",
            "F": "Mazak-i200.robot",
            "I": "Mazak-i200.png",
            "B": "Mazak",
            "M": "i200",
            "T": "Mechanism",
            "A": 1
        },
        "OnRobot-Lift100-Vertical-Axis": {
            "MT": "M",
            "N": "OnRobot Lift100 Vertical Axis",
            "F": "OnRobot-Lift100-Vertical-Axis.rdka",
            "I": "OnRobot-Lift100-Vertical-Axis.png",
            "B": "OnRobot",
            "M": "Lift100 Vertical Axis",
            "T": "Mechanism",
            "A": 1
        },
        "Reis-RL130P-CNC": {
            "MT": "M",
            "N": "Reis RL130P CNC",
            "F": "Reis-RL130P-CNC.robot",
            "I": "Reis-RL130P-CNC.png",
            "B": "Reis",
            "M": "RL130P CNC",
            "T": "Mechanism",
            "A": 5,
            "R": 1500,
            "P": 100,
            "E": 0.1,
            "AP": [
                "Machining"
            ]
        },
        "Renishaw-RCS-L-90-Ballbar": {
            "MT": "M",
            "N": "Renishaw RCS L-90 Ballbar",
            "F": "Renishaw-RCS-L-90-Ballbar.rdka",
            "I": "Renishaw-RCS-L-90-Ballbar.png",
            "B": "Renishaw",
            "M": "RCS L-90 Ballbar",
            "T": "Mechanism",
            "A": 2
        },
        "uFactory-Direct-Drive-Linear-Motor": {
            "MT": "M",
            "N": "uFactory Direct-Drive Linear Motor",
            "F": "uFactory-Direct-Drive-Linear-Motor.robot",
            "I": "uFactory-Direct-Drive-Linear-Motor.png",
            "B": "uFactory",
            "M": "Direct-Drive Linear Motor",
            "T": "Mechanism",
            "A": 1
        },
        "Exechon-PKM-XMINI": {
            "MT": "M",
            "N": "Exechon PKM XMINI",
            "F": "Exechon-PKM-XMINI.robot",
            "I": "Exechon-PKM-XMINI.png",
            "B": "Exechon",
            "M": "PKM XMINI",
            "T": "Tricept",
            "A": 5,
            "R": 250,
            "P": 50,
            "W": 300,
            "E": 0.005
        },
        "Box-12x7in-Closed": {
            "MT": "O",
            "N": "Box 12x7in (Closed)",
            "F": "Box-12x7in-Closed.sld",
            "I": "Box-12x7in-Closed.png",
            "M": "12x7in (Closed)",
            "T": "Box",
            "A": 0
        },
        "Box-12x10in-Closed": {
            "MT": "O",
            "N": "Box 12x10in (Closed)",
            "F": "Box-12x10in-Closed.sld",
            "I": "Box-12x10in-Closed.png",
            "M": "12x10in (Closed)",
            "T": "Box",
            "A": 0
        },
        "Box-12x10in-Open": {
            "MT": "O",
            "N": "Box 12x10in (Open)",
            "F": "Box-12x10in-Open.sld",
            "I": "Box-12x10in-Open.png",
            "M": "12x10in (Open)",
            "T": "Box",
            "A": 0
        },
        "Box-20x12in-Closed": {
            "MT": "O",
            "N": "Box 20x12in (Closed)",
            "F": "Box-20x12in-Closed.sld",
            "I": "Box-20x12in-Closed.png",
            "M": "20x12in (Closed)",
            "T": "Box",
            "A": 0
        },
        "Box-20x12in-Open": {
            "MT": "O",
            "N": "Box 20x12in (Open)",
            "F": "Box-20x12in-Open.sld",
            "I": "Box-20x12in-Open.png",
            "M": "20x12in (Open)",
            "T": "Box",
            "A": 0
        },
        "Box-24x16in-Closed": {
            "MT": "O",
            "N": "Box 24x16in (Closed)",
            "F": "Box-24x16in-Closed.sld",
            "I": "Box-24x16in-Closed.png",
            "M": "24x16in (Closed)",
            "T": "Box",
            "A": 0
        },
        "Box-24x16in-Open": {
            "MT": "O",
            "N": "Box 24x16in (Open)",
            "F": "Box-24x16in-Open.sld",
            "I": "Box-24x16in-Open.png",
            "M": "24x16in (Open)",
            "T": "Box",
            "A": 0
        },
        "Box-215x215mm-Fold-1": {
            "MT": "O",
            "N": "Box 215x215mm (Fold 1)",
            "F": "Box-215x215mm-Fold-1.sld",
            "I": "Box-215x215mm-Fold-1.png",
            "M": "215x215mm (Fold 1)",
            "T": "Box",
            "A": 0
        },
        "Box-215x215mm-Fold-2": {
            "MT": "O",
            "N": "Box 215x215mm (Fold 2)",
            "F": "Box-215x215mm-Fold-2.sld",
            "I": "Box-215x215mm-Fold-2.png",
            "M": "215x215mm (Fold 2)",
            "T": "Box",
            "A": 0
        },
        "Box-215x215mm-Fold-3": {
            "MT": "O",
            "N": "Box 215x215mm (Fold 3)",
            "F": "Box-215x215mm-Fold-3.sld",
            "I": "Box-215x215mm-Fold-3.png",
            "M": "215x215mm (Fold 3)",
            "T": "Box",
            "A": 0
        },
        "Box-215x215mm-Folded": {
            "MT": "O",
            "N": "Box 215x215mm (Folded)",
            "F": "Box-215x215mm-Folded.sld",
            "I": "Box-215x215mm-Folded.png",
            "M": "215x215mm (Folded)",
            "T": "Box",
            "A": 0
        },
        "Box-215x215mm-Unfolded": {
            "MT": "O",
            "N": "Box 215x215mm (Unfolded)",
            "F": "Box-215x215mm-Unfolded.sld",
            "I": "Box-215x215mm-Unfolded.png",
            "M": "215x215mm (Unfolded)",
            "T": "Box",
            "A": 0
        },
        "Box-400x200mm-Closed": {
            "MT": "O",
            "N": "Box 400x200mm (Closed)",
            "F": "Box-400x200mm-Closed.sld",
            "I": "Box-400x200mm-Closed.png",
            "M": "400x200mm (Closed)",
            "T": "Box",
            "A": 0
        },
        "Box-400x200mm-Open": {
            "MT": "O",
            "N": "Box 400x200mm (Open)",
            "F": "Box-400x200mm-Open.sld",
            "I": "Box-400x200mm-Open.png",
            "M": "400x200mm (Open)",
            "T": "Box",
            "A": 0
        },
        "Box-Erector-Station": {
            "MT": "O",
            "N": "Box Erector Station",
            "F": "Box-Erector-Station.sld",
            "I": "Box-Erector-Station.png",
            "M": "Erector Station",
            "T": "Box",
            "A": 0
        },
        "Intel-RealSense-D415-Camera": {
            "MT": "O",
            "N": "Intel RealSense D415 Camera",
            "F": "Intel-RealSense-D415-Camera.sld",
            "I": "Intel-RealSense-D415-Camera.png",
            "B": "Intel",
            "M": "RealSense D415 Camera",
            "T": "Camera",
            "A": 0,
            "AP": [
                "Inspection"
            ]
        },
        "Intel-RealSense-D435-Camera": {
            "MT": "O",
            "N": "Intel RealSense D435 Camera",
            "F": "Intel-RealSense-D435-Camera.sld",
            "I": "Intel-RealSense-D435-Camera.png",
            "B": "Intel",
            "M": "RealSense D435 Camera",
            "T": "Camera",
            "A": 0,
            "AP": [
                "Inspection"
            ]
        },
        "Intel-RealSense-SR305-Camera": {
            "MT": "O",
            "N": "Intel RealSense SR305 Camera",
            "F": "Intel-RealSense-SR305-Camera.sld",
            "I": "Intel-RealSense-SR305-Camera.png",
            "B": "Intel",
            "M": "RealSense SR305 Camera",
            "T": "Camera",
            "A": 0,
            "AP": [
                "Inspection"
            ]
        },
        "Intel-RealSense-T265-Camera": {
            "MT": "O",
            "N": "Intel RealSense T265 Camera",
            "F": "Intel-RealSense-T265-Camera.sld",
            "I": "Intel-RealSense-T265-Camera.png",
            "B": "Intel",
            "M": "RealSense T265 Camera",
            "T": "Camera",
            "A": 0,
            "AP": [
                "Inspection"
            ]
        },
        "Matrox-Iris-GTR-Camera": {
            "MT": "O",
            "N": "Matrox Iris GTR Camera",
            "F": "Matrox-Iris-GTR-Camera.sld",
            "I": "Matrox-Iris-GTR-Camera.png",
            "B": "Matrox",
            "M": "Iris GTR Camera",
            "T": "Camera",
            "A": 0,
            "AP": [
                "Inspection"
            ]
        },
        "OpenCV-OAK-1-Camera": {
            "MT": "O",
            "N": "OpenCV OAK-1 Camera",
            "F": "OpenCV-OAK-1-Camera.sld",
            "I": "OpenCV-OAK-1-Camera.png",
            "B": "OpenCV",
            "M": "OAK-1 Camera",
            "T": "Camera",
            "A": 0,
            "AP": [
                "Inspection"
            ]
        },
        "OpenCV-OAK-1-POE-Camera": {
            "MT": "O",
            "N": "OpenCV OAK-1 POE Camera",
            "F": "OpenCV-OAK-1-POE-Camera.sld",
            "I": "OpenCV-OAK-1-POE-Camera.png",
            "B": "OpenCV",
            "M": "OAK-1 POE Camera",
            "T": "Camera",
            "A": 0,
            "AP": [
                "Inspection"
            ]
        },
        "OpenCV-OAK-D-Camera": {
            "MT": "O",
            "N": "OpenCV OAK-D Camera",
            "F": "OpenCV-OAK-D-Camera.sld",
            "I": "OpenCV-OAK-D-Camera.png",
            "B": "OpenCV",
            "M": "OAK-D Camera",
            "T": "Camera",
            "A": 0,
            "AP": [
                "Inspection"
            ]
        },
        "OpenCV-OAK-D-POE-Camera": {
            "MT": "O",
            "N": "OpenCV OAK-D POE Camera",
            "F": "OpenCV-OAK-D-POE-Camera.sld",
            "I": "OpenCV-OAK-D-POE-Camera.png",
            "B": "OpenCV",
            "M": "OAK-D POE Camera",
            "T": "Camera",
            "A": 0,
            "AP": [
                "Inspection"
            ]
        },
        "SICK-PLB510-Camera": {
            "MT": "O",
            "N": "SICK PLB510 Camera",
            "F": "SICK-PLB510-Camera.sld",
            "I": "SICK-PLB510-Camera.png",
            "B": "SICK",
            "M": "PLB510 Camera",
            "T": "Camera",
            "A": 0,
            "AP": [
                "Inspection"
            ]
        },
        "SICK-PLB515-Camera": {
            "MT": "O",
            "N": "SICK PLB515 Camera",
            "F": "SICK-PLB515-Camera.sld",
            "I": "SICK-PLB515-Camera.png",
            "B": "SICK",
            "M": "PLB515 Camera",
            "T": "Camera",
            "A": 0,
            "AP": [
                "Inspection"
            ]
        },
        "SICK-PLB520-M-Camera": {
            "MT": "O",
            "N": "SICK PLB520-M Camera",
            "F": "SICK-PLB520-M-Camera.sld",
            "I": "SICK-PLB520-M-Camera.png",
            "B": "SICK",
            "M": "PLB520-M Camera",
            "T": "Camera",
            "A": 0,
            "AP": [
                "Inspection"
            ]
        },
        "SICK-PLB530-M-Camera": {
            "MT": "O",
            "N": "SICK PLB530-M Camera",
            "F": "SICK-PLB530-M-Camera.sld",
            "I": "SICK-PLB530-M-Camera.png",
            "B": "SICK",
            "M": "PLB530-M Camera",
            "T": "Camera",
            "A": 0,
            "AP": [
                "Inspection"
            ]
        },
        "SICK-PLB535-Camera": {
            "MT": "O",
            "N": "SICK PLB535 Camera",
            "F": "SICK-PLB535-Camera.sld",
            "I": "SICK-PLB535-Camera.png",
            "B": "SICK",
            "M": "PLB535 Camera",
            "T": "Camera",
            "A": 0,
            "AP": [
                "Inspection"
            ]
        },
        "SICK-PLB540-Camera": {
            "MT": "O",
            "N": "SICK PLB540 Camera",
            "F": "SICK-PLB540-Camera.sld",
            "I": "SICK-PLB540-Camera.png",
            "B": "SICK",
            "M": "PLB540 Camera",
            "T": "Camera",
            "A": 0,
            "AP": [
                "Inspection"
            ]
        },
        "SICK-VSPP-5F2113-Camera": {
            "MT": "O",
            "N": "SICK VSPP-5F2113 Camera",
            "F": "SICK-VSPP-5F2113-Camera.sld",
            "I": "SICK-VSPP-5F2113-Camera.png",
            "B": "SICK",
            "M": "VSPP-5F2113 Camera",
            "T": "Camera",
            "A": 0,
            "AP": [
                "Inspection"
            ]
        },
        "Creaform-CUBE-R-Example": {
            "MT": "O",
            "N": "Creaform CUBE-R (Example)",
            "F": "Creaform-CUBE-R-Example.rdk",
            "I": "Creaform-CUBE-R-Example.png",
            "B": "Creaform",
            "M": "CUBE-R (Example)",
            "T": "Cell",
            "A": 7
        },
        "Creaform-CUBE-R-Setup": {
            "MT": "O",
            "N": "Creaform CUBE-R (Setup)",
            "F": "Creaform-CUBE-R-Setup.rdk",
            "I": "Creaform-CUBE-R-Setup.png",
            "B": "Creaform",
            "M": "CUBE-R (Setup)",
            "T": "Cell",
            "A": 7
        },
        "DIY-Robotics-Astro-33": {
            "MT": "O",
            "N": "DIY Robotics Astro-33",
            "F": "DIY-Robotics-Astro-33.rdka",
            "I": "DIY-Robotics-Astro-33.png",
            "B": "DIY Robotics",
            "M": "Astro-33",
            "T": "Cell",
            "A": 6
        },
        "DIY-Robotics-Comet-33": {
            "MT": "O",
            "N": "DIY Robotics Comet-33",
            "F": "DIY-Robotics-Comet-33.rdka",
            "I": "DIY-Robotics-Comet-33.png",
            "B": "DIY Robotics",
            "M": "Comet-33",
            "T": "Cell",
            "A": 6
        },
        "DIY-Robotics-Comet-44": {
            "MT": "O",
            "N": "DIY Robotics Comet-44",
            "F": "DIY-Robotics-Comet-44.rdka",
            "I": "DIY-Robotics-Comet-44.png",
            "B": "DIY Robotics",
            "M": "Comet-44",
            "T": "Cell",
            "A": 6
        },
        "DIY-Robotics-Satellite-55": {
            "MT": "O",
            "N": "DIY Robotics Satellite-55",
            "F": "DIY-Robotics-Satellite-55.rdka",
            "I": "DIY-Robotics-Satellite-55.png",
            "B": "DIY Robotics",
            "M": "Satellite-55",
            "T": "Cell",
            "A": 6
        },
        "DIY-Robotics-Satellite-66": {
            "MT": "O",
            "N": "DIY Robotics Satellite-66",
            "F": "DIY-Robotics-Satellite-66.rdka",
            "I": "DIY-Robotics-Satellite-66.png",
            "B": "DIY Robotics",
            "M": "Satellite-66",
            "T": "Cell",
            "A": 6
        },
        "Lorch-Cobot-Welding-Station-MIG-MAG": {
            "MT": "O",
            "N": "Lorch Cobot Welding Station (MIG-MAG)",
            "F": "Lorch-Cobot-Welding-Station-MIG-MAG.rdka",
            "I": "Lorch-Cobot-Welding-Station-MIG-MAG.png",
            "B": "Lorch",
            "M": "Cobot Welding Station (MIG-MAG)",
            "T": "Cell",
            "A": 6,
            "AP": [
                "Welding"
            ]
        },
        "Pallet-40x48in": {
            "MT": "O",
            "N": "Pallet 40x48in",
            "F": "Pallet-40x48in.sld",
            "I": "Pallet-40x48in.png",
            "M": "40x48in",
            "T": "Pallet",
            "A": 0,
            "AP": [
                "Palletizing"
            ]
        },
        "Pallet-48x48in": {
            "MT": "O",
            "N": "Pallet 48x48in",
            "F": "Pallet-48x48in.sld",
            "I": "Pallet-48x48in.png",
            "M": "48x48in",
            "T": "Pallet",
            "A": 0,
            "AP": [
                "Palletizing"
            ]
        },
        "Pallet-1130x1130mm": {
            "MT": "O",
            "N": "Pallet 1130x1130mm",
            "F": "Pallet-1130x1130mm.sld",
            "I": "Pallet-1130x1130mm.png",
            "M": "1130x1130mm",
            "T": "Pallet",
            "A": 0,
            "AP": [
                "Palletizing"
            ]
        },
        "Pallet-1200x800mm-Transverse": {
            "MT": "O",
            "N": "Pallet 1200x800mm (Transverse)",
            "F": "Pallet-1200x800mm-Transverse.sld",
            "I": "Pallet-1200x800mm-Transverse.png",
            "M": "1200x800mm (Transverse)",
            "T": "Pallet",
            "A": 0,
            "AP": [
                "Palletizing"
            ]
        },
        "Pallet-1200x800mm": {
            "MT": "O",
            "N": "Pallet 1200x800mm",
            "F": "Pallet-1200x800mm.sld",
            "I": "Pallet-1200x800mm.png",
            "M": "1200x800mm",
            "T": "Pallet",
            "A": 0,
            "AP": [
                "Palletizing"
            ]
        },
        "Pallet-1625x1350mm": {
            "MT": "O",
            "N": "Pallet 1625x1350mm",
            "F": "Pallet-1625x1350mm.sld",
            "I": "Pallet-1625x1350mm.png",
            "M": "1625x1350mm",
            "T": "Pallet",
            "A": 0,
            "AP": [
                "Palletizing"
            ]
        },
        "Pedestal-H12in-Type-1": {
            "MT": "O",
            "N": "Pedestal H12in (Type 1)",
            "F": "Pedestal-H12in-Type-1.sld",
            "I": "Pedestal-H12in-Type-1.png",
            "M": "H12in (Type 1)",
            "T": "Pedestal",
            "A": 0
        },
        "Pedestal-H24in-Type-1": {
            "MT": "O",
            "N": "Pedestal H24in (Type 1)",
            "F": "Pedestal-H24in-Type-1.sld",
            "I": "Pedestal-H24in-Type-1.png",
            "M": "H24in (Type 1)",
            "T": "Pedestal",
            "A": 0
        },
        "Pedestal-H36in-Type-1": {
            "MT": "O",
            "N": "Pedestal H36in (Type 1)",
            "F": "Pedestal-H36in-Type-1.sld",
            "I": "Pedestal-H36in-Type-1.png",
            "M": "H36in (Type 1)",
            "T": "Pedestal",
            "A": 0
        },
        "Pedestal-H500mm-Type-2": {
            "MT": "O",
            "N": "Pedestal H500mm (Type 2)",
            "F": "Pedestal-H500mm-Type-2.sld",
            "I": "Pedestal-H500mm-Type-2.png",
            "M": "H500mm (Type 2)",
            "T": "Pedestal",
            "A": 0
        },
        "Pedestal-H650mm-Type-2": {
            "MT": "O",
            "N": "Pedestal H650mm (Type 2)",
            "F": "Pedestal-H650mm-Type-2.sld",
            "I": "Pedestal-H650mm-Type-2.png",
            "M": "H650mm (Type 2)",
            "T": "Pedestal",
            "A": 0
        },
        "Pedestal-H750mm-Type-2": {
            "MT": "O",
            "N": "Pedestal H750mm (Type 2)",
            "F": "Pedestal-H750mm-Type-2.sld",
            "I": "Pedestal-H750mm-Type-2.png",
            "M": "H750mm (Type 2)",
            "T": "Pedestal",
            "A": 0
        },
        "Pedestal-H1000mm-Type-2": {
            "MT": "O",
            "N": "Pedestal H1000mm (Type 2)",
            "F": "Pedestal-H1000mm-Type-2.sld",
            "I": "Pedestal-H1000mm-Type-2.png",
            "M": "H1000mm (Type 2)",
            "T": "Pedestal",
            "A": 0
        },
        "Circle": {
            "MT": "O",
            "N": "Circle",
            "F": "Circle.sld",
            "I": "Circle.png",
            "T": "Shape",
            "A": 0
        },
        "Cone-100x100mm": {
            "MT": "O",
            "N": "Cone 100x100mm",
            "F": "Cone-100x100mm.sld",
            "I": "Cone-100x100mm.png",
            "M": "100x100mm",
            "T": "Shape",
            "A": 0
        },
        "Cone-500x500mm": {
            "MT": "O",
            "N": "Cone 500x500mm",
            "F": "Cone-500x500mm.sld",
            "I": "Cone-500x500mm.png",
            "M": "500x500mm",
            "T": "Shape",
            "A": 0
        },
        "Cone-1000x1000mm": {
            "MT": "O",
            "N": "Cone 1000x1000mm",
            "F": "Cone-1000x1000mm.sld",
            "I": "Cone-1000x1000mm.png",
            "M": "1000x1000mm",
            "T": "Shape",
            "A": 0
        },
        "Cube-50mm": {
            "MT": "O",
            "N": "Cube 50mm",
            "F": "Cube-50mm.sld",
            "I": "Cube-50mm.png",
            "M": "50mm",
            "T": "Shape",
            "A": 0
        },
        "Cube-100mm": {
            "MT": "O",
            "N": "Cube 100mm",
            "F": "Cube-100mm.sld",
            "I": "Cube-100mm.png",
            "M": "100mm",
            "T": "Shape",
            "A": 0
        },
        "Cube-500mm": {
            "MT": "O",
            "N": "Cube 500mm",
            "F": "Cube-500mm.sld",
            "I": "Cube-500mm.png",
            "M": "500mm",
            "T": "Shape",
            "A": 0
        },
        "Cube-1000mm": {
            "MT": "O",
            "N": "Cube 1000mm",
            "F": "Cube-1000mm.sld",
            "I": "Cube-1000mm.png",
            "M": "1000mm",
            "T": "Shape",
            "A": 0
        },
        "Cylinder-50x150mm": {
            "MT": "O",
            "N": "Cylinder 50x150mm",
            "F": "Cylinder-50x150mm.sld",
            "I": "Cylinder-50x150mm.png",
            "M": "50x150mm",
            "T": "Shape",
            "A": 0
        },
        "Cylinder-100x300mm": {
            "MT": "O",
            "N": "Cylinder 100x300mm",
            "F": "Cylinder-100x300mm.sld",
            "I": "Cylinder-100x300mm.png",
            "M": "100x300mm",
            "T": "Shape",
            "A": 0
        },
        "Cylinder-150x450mm": {
            "MT": "O",
            "N": "Cylinder 150x450mm",
            "F": "Cylinder-150x450mm.sld",
            "I": "Cylinder-150x450mm.png",
            "M": "150x450mm",
            "T": "Shape",
            "A": 0
        },
        "Cylinder-500x1500mm": {
            "MT": "O",
            "N": "Cylinder 500x1500mm",
            "F": "Cylinder-500x1500mm.sld",
            "I": "Cylinder-500x1500mm.png",
            "M": "500x1500mm",
            "T": "Shape",
            "A": 0
        },
        "Hexagon": {
            "MT": "O",
            "N": "Hexagon",
            "F": "Hexagon.sld",
            "I": "Hexagon.png",
            "T": "Shape",
            "A": 0
        },
        "Prism-250x125x125mm": {
            "MT": "O",
            "N": "Prism 250x125x125mm",
            "F": "Prism-250x125x125mm.sld",
            "I": "Prism-250x125x125mm.png",
            "M": "250x125x125mm",
            "T": "Shape",
            "A": 0
        },
        "Prism-500x250x250mm": {
            "MT": "O",
            "N": "Prism 500x250x250mm",
            "F": "Prism-500x250x250mm.sld",
            "I": "Prism-500x250x250mm.png",
            "M": "500x250x250mm",
            "T": "Shape",
            "A": 0
        },
        "Prism-1000x500x500mm": {
            "MT": "O",
            "N": "Prism 1000x500x500mm",
            "F": "Prism-1000x500x500mm.sld",
            "I": "Prism-1000x500x500mm.png",
            "M": "1000x500x500mm",
            "T": "Shape",
            "A": 0
        },
        "Pyramid-B200xH150mm": {
            "MT": "O",
            "N": "Pyramid B200xH150mm",
            "F": "Pyramid-B200xH150mm.sld",
            "I": "Pyramid-B200xH150mm.png",
            "M": "B200xH150mm",
            "T": "Shape",
            "A": 0
        },
        "Pyramid-B500xH375mm": {
            "MT": "O",
            "N": "Pyramid B500xH375mm",
            "F": "Pyramid-B500xH375mm.sld",
            "I": "Pyramid-B500xH375mm.png",
            "M": "B500xH375mm",
            "T": "Shape",
            "A": 0
        },
        "Pyramid-B1000xH750mm": {
            "MT": "O",
            "N": "Pyramid B1000xH750mm",
            "F": "Pyramid-B1000xH750mm.sld",
            "I": "Pyramid-B1000xH750mm.png",
            "M": "B1000xH750mm",
            "T": "Shape",
            "A": 0
        },
        "Semi-Sphere-D100mm": {
            "MT": "O",
            "N": "Semi-Sphere D100mm",
            "F": "Semi-Sphere-D100mm.sld",
            "I": "Semi-Sphere-D100mm.png",
            "M": "D100mm",
            "T": "Shape",
            "A": 0
        },
        "Semi-Sphere-D500mm": {
            "MT": "O",
            "N": "Semi-Sphere D500mm",
            "F": "Semi-Sphere-D500mm.sld",
            "I": "Semi-Sphere-D500mm.png",
            "M": "D500mm",
            "T": "Shape",
            "A": 0
        },
        "Semi-Sphere-D1000mm": {
            "MT": "O",
            "N": "Semi-Sphere D1000mm",
            "F": "Semi-Sphere-D1000mm.sld",
            "I": "Semi-Sphere-D1000mm.png",
            "M": "D1000mm",
            "T": "Shape",
            "A": 0
        },
        "Sphere-D100mm": {
            "MT": "O",
            "N": "Sphere D100mm",
            "F": "Sphere-D100mm.sld",
            "I": "Sphere-D100mm.png",
            "M": "D100mm",
            "T": "Shape",
            "A": 0
        },
        "Sphere-D500mm": {
            "MT": "O",
            "N": "Sphere D500mm",
            "F": "Sphere-D500mm.sld",
            "I": "Sphere-D500mm.png",
            "M": "D500mm",
            "T": "Shape",
            "A": 0
        },
        "Sphere-D1000mm": {
            "MT": "O",
            "N": "Sphere D1000mm",
            "F": "Sphere-D1000mm.sld",
            "I": "Sphere-D1000mm.png",
            "M": "D1000mm",
            "T": "Shape",
            "A": 0
        },
        "Spherocylinder-100x300mm": {
            "MT": "O",
            "N": "Spherocylinder 100x300mm",
            "F": "Spherocylinder-100x300mm.sld",
            "I": "Spherocylinder-100x300mm.png",
            "M": "100x300mm",
            "T": "Shape",
            "A": 0
        },
        "Spherocylinder-300x600mm": {
            "MT": "O",
            "N": "Spherocylinder 300x600mm",
            "F": "Spherocylinder-300x600mm.sld",
            "I": "Spherocylinder-300x600mm.png",
            "M": "300x600mm",
            "T": "Shape",
            "A": 0
        },
        "Spherocylinder-500x1500mm": {
            "MT": "O",
            "N": "Spherocylinder 500x1500mm",
            "F": "Spherocylinder-500x1500mm.sld",
            "I": "Spherocylinder-500x1500mm.png",
            "M": "500x1500mm",
            "T": "Shape",
            "A": 0
        },
        "Square": {
            "MT": "O",
            "N": "Square",
            "F": "Square.sld",
            "I": "Square.png",
            "T": "Shape",
            "A": 0
        },
        "Triangle": {
            "MT": "O",
            "N": "Triangle",
            "F": "Triangle.sld",
            "I": "Triangle.png",
            "T": "Shape",
            "A": 0
        },
        "Table-108x114x32in": {
            "MT": "O",
            "N": "Table 108x114x32in",
            "F": "Table-108x114x32in.sld",
            "I": "Table-108x114x32in.png",
            "M": "108x114x32in",
            "T": "Table",
            "A": 0
        },
        "Table-1200x1000mm-Welding": {
            "MT": "O",
            "N": "Table 1200x1000mm (Welding)",
            "F": "Table-1200x1000mm-Welding.sld",
            "I": "Table-1200x1000mm-Welding.png",
            "M": "1200x1000mm (Welding)",
            "T": "Table",
            "A": 0
        },
        "Table-1400x800x800mm": {
            "MT": "O",
            "N": "Table 1400x800x800mm",
            "F": "Table-1400x800x800mm.sld",
            "I": "Table-1400x800x800mm.png",
            "M": "1400x800x800mm",
            "T": "Table",
            "A": 0
        },
        "Table-1500x1400x785mm-Laser-Cutting": {
            "MT": "O",
            "N": "Table 1500x1400x785mm (Laser Cutting)",
            "F": "Table-1500x1400x785mm-Laser-Cutting.sld",
            "I": "Table-1500x1400x785mm-Laser-Cutting.png",
            "M": "1500x1400x785mm (Laser Cutting)",
            "T": "Table",
            "A": 0
        },
        "Table-2000x1200x800mm": {
            "MT": "O",
            "N": "Table 2000x1200x800mm",
            "F": "Table-2000x1200x800mm.sld",
            "I": "Table-2000x1200x800mm.png",
            "M": "2000x1200x800mm",
            "T": "Table",
            "A": 0
        },
        "API-OT2-Laser-Tracker": {
            "MT": "O",
            "N": "API OT2 Laser Tracker",
            "F": "API-OT2-Laser-Tracker.robot",
            "I": "API-OT2-Laser-Tracker.png",
            "B": "API",
            "M": "OT2 Laser Tracker",
            "T": "Tracker",
            "A": 2,
            "AP": [
                "Calibration",
                "Inspection"
            ]
        },
        "API-Radian-Laser-Tracker": {
            "MT": "O",
            "N": "API Radian Laser Tracker",
            "F": "API-Radian-Laser-Tracker.robot",
            "I": "API-Radian-Laser-Tracker.png",
            "B": "API",
            "M": "Radian Laser Tracker",
            "T": "Tracker",
            "A": 2,
            "AP": [
                "Calibration",
                "Inspection"
            ]
        },
        "Creaform-C-Track": {
            "MT": "O",
            "N": "Creaform C-Track",
            "F": "Creaform-C-Track.rdka",
            "I": "Creaform-C-Track.png",
            "B": "Creaform",
            "M": "C-Track",
            "T": "Tracker",
            "A": 0
        },
        "FARO-ION-Laser-Tracker": {
            "MT": "O",
            "N": "FARO ION Laser Tracker",
            "F": "FARO-ION-Laser-Tracker.rdka",
            "I": "FARO-ION-Laser-Tracker.png",
            "B": "FARO",
            "M": "ION Laser Tracker",
            "T": "Tracker",
            "A": 0,
            "AP": [
                "Calibration",
                "Inspection"
            ]
        },
        "Leica-AT401-Laser-Tracker": {
            "MT": "O",
            "N": "Leica AT401 Laser Tracker",
            "F": "Leica-AT401-Laser-Tracker.sld",
            "I": "Leica-AT401-Laser-Tracker.png",
            "B": "Leica",
            "M": "AT401 Laser Tracker",
            "T": "Tracker",
            "A": 0,
            "AP": [
                "Calibration",
                "Inspection"
            ]
        },
        "Leica-AT960-Laser-Tracker": {
            "MT": "O",
            "N": "Leica AT960 Laser Tracker",
            "F": "Leica-AT960-Laser-Tracker.sld",
            "I": "Leica-AT960-Laser-Tracker.png",
            "B": "Leica",
            "M": "AT960 Laser Tracker",
            "T": "Tracker",
            "A": 0,
            "AP": [
                "Calibration",
                "Inspection"
            ]
        },
        "Bin-Blue": {
            "MT": "O",
            "N": "Bin Blue",
            "F": "Bin-Blue.sld",
            "I": "Bin-Blue.png",
            "M": "Blue",
            "T": "Object",
            "A": 0
        },
        "Bin-Pink": {
            "MT": "O",
            "N": "Bin Pink",
            "F": "Bin-Pink.sld",
            "I": "Bin-Pink.png",
            "M": "Pink",
            "T": "Object",
            "A": 0
        },
        "Bin-Red": {
            "MT": "O",
            "N": "Bin Red",
            "F": "Bin-Red.sld",
            "I": "Bin-Red.png",
            "M": "Red",
            "T": "Object",
            "A": 0
        },
        "Bottle-Label": {
            "MT": "O",
            "N": "Bottle (Label)",
            "F": "Bottle-Label.sld",
            "I": "Bottle-Label.png",
            "M": "Label",
            "T": "Object",
            "A": 0
        },
        "Bottle-Plain": {
            "MT": "O",
            "N": "Bottle (Plain)",
            "F": "Bottle-Plain.sld",
            "I": "Bottle-Plain.png",
            "M": "Plain",
            "T": "Object",
            "A": 0
        },
        "Cell-Frame": {
            "MT": "O",
            "N": "Cell Frame",
            "F": "Cell-Frame.sld",
            "I": "Cell-Frame.png",
            "T": "Object",
            "A": 0
        },
        "Cell-Safety-Grid": {
            "MT": "O",
            "N": "Cell Safety Grid",
            "F": "Cell-Safety-Grid.sld",
            "I": "Cell-Safety-Grid.png",
            "T": "Object",
            "A": 0
        },
        "Cell-Safety-Panels": {
            "MT": "O",
            "N": "Cell Safety Panels",
            "F": "Cell-Safety-Panels.sld",
            "I": "Cell-Safety-Panels.png",
            "T": "Object",
            "A": 0
        },
        "Display-Panel-24in": {
            "MT": "O",
            "N": "Display Panel 24in",
            "F": "Display-Panel-24in.sld",
            "I": "Display-Panel-24in.png",
            "M": "24in",
            "T": "Object",
            "A": 0,
            "AP": [
                "HMI"
            ]
        },
        "Floor": {
            "MT": "O",
            "N": "Floor",
            "F": "Floor.sld",
            "I": "Floor.png",
            "T": "Object",
            "A": 0
        },
        "Grid": {
            "MT": "O",
            "N": "Grid",
            "F": "Grid.sld",
            "I": "Grid.png",
            "T": "Object",
            "A": 0
        },
        "IDEC-SE2L-H05LP-Laser-Scanner": {
            "MT": "O",
            "N": "IDEC SE2L-H05LP Laser Scanner",
            "F": "IDEC-SE2L-H05LP-Laser-Scanner.sld",
            "I": "IDEC-SE2L-H05LP-Laser-Scanner.png",
            "T": "Object",
            "A": 0,
            "AP": [
                "Inspection"
            ]
        },
        "Light-Green": {
            "MT": "O",
            "N": "Light (Green)",
            "F": "Light-Green.sld",
            "I": "Light-Green.png",
            "M": "Green",
            "T": "Object",
            "A": 0
        },
        "Light-Off": {
            "MT": "O",
            "N": "Light (Off)",
            "F": "Light-Off.sld",
            "I": "Light-Off.png",
            "M": "Off",
            "T": "Object",
            "A": 0
        },
        "Light-Red": {
            "MT": "O",
            "N": "Light (Red)",
            "F": "Light-Red.sld",
            "I": "Light-Red.png",
            "M": "Red",
            "T": "Object",
            "A": 0
        },
        "RAYSAN-1R-Zeta-Rack-End-Barrier": {
            "MT": "O",
            "N": "RAYSAN 1R Zeta Rack End Barrier",
            "F": "RAYSAN-1R-Zeta-Rack-End-Barrier.sld",
            "I": "RAYSAN-1R-Zeta-Rack-End-Barrier.png",
            "T": "Object",
            "A": 0
        },
        "Renishaw-QC20-W-Ballbar": {
            "MT": "O",
            "N": "Renishaw QC20-W Ballbar",
            "F": "Renishaw-QC20-W-Ballbar.sld",
            "I": "Renishaw-QC20-W-Ballbar.png",
            "B": "Renishaw",
            "M": "QC20-W Ballbar",
            "T": "Object",
            "A": 0
        },
        "RoboDK-Logo-Plate-100x100mm": {
            "MT": "O",
            "N": "RoboDK Logo Plate 100x100mm",
            "F": "RoboDK-Logo-Plate-100x100mm.sld",
            "I": "RoboDK-Logo-Plate-100x100mm.png",
            "B": "RoboDK",
            "M": "Logo Plate 100x100mm",
            "T": "Object",
            "A": 0
        },
        "RoboDK-Logo-Shield-D100mm": {
            "MT": "O",
            "N": "RoboDK Logo Shield D100mm",
            "F": "RoboDK-Logo-Shield-D100mm.sld",
            "I": "RoboDK-Logo-Shield-D100mm.png",
            "B": "RoboDK",
            "M": "Logo Shield D100mm",
            "T": "Object",
            "A": 0
        },
        "RoboDK-Nametag-Plate-500x200mm": {
            "MT": "O",
            "N": "RoboDK Nametag Plate 500x200mm",
            "F": "RoboDK-Nametag-Plate-500x200mm.sld",
            "I": "RoboDK-Nametag-Plate-500x200mm.png",
            "B": "RoboDK",
            "M": "Nametag Plate 500x200mm",
            "T": "Object",
            "A": 0
        },
        "RoboDK-RDK-Plate-100x100mm": {
            "MT": "O",
            "N": "RoboDK RDK Plate 100x100mm",
            "F": "RoboDK-RDK-Plate-100x100mm.sld",
            "I": "RoboDK-RDK-Plate-100x100mm.png",
            "B": "RoboDK",
            "M": "RDK Plate 100x100mm",
            "T": "Object",
            "A": 0
        },
        "RoboDK-Test-Plate-550x400mm": {
            "MT": "O",
            "N": "RoboDK Test Plate 550x400mm",
            "F": "RoboDK-Test-Plate-550x400mm.sld",
            "I": "RoboDK-Test-Plate-550x400mm.png",
            "B": "RoboDK",
            "M": "Test Plate 550x400mm",
            "T": "Object",
            "A": 0
        },
        "SICK-WL4S-Laser-Sensor": {
            "MT": "O",
            "N": "SICK WL4S Laser Sensor",
            "F": "SICK-WL4S-Laser-Sensor.sld",
            "I": "SICK-WL4S-Laser-Sensor.png",
            "B": "SICK",
            "M": "WL4S Laser Sensor",
            "T": "Object",
            "A": 0
        },
        "Zivid-ZVDA-CB01-Calibration-Board": {
            "MT": "O",
            "N": "Zivid ZVDA-CB01 Calibration Board",
            "F": "Zivid-ZVDA-CB01-Calibration-Board.sld",
            "I": "Zivid-ZVDA-CB01-Calibration-Board.png",
            "B": "Zivid",
            "M": "ZVDA-CB01 Calibration Board",
            "T": "Object",
            "A": 0,
            "AP": [
                "Calibration"
            ]
        }
    }
}